import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDocumentEmailTag implements BaseEnumType {
  private static allValues: EnumDocumentEmailTag[] = []; // make sure this is top-most
  
  public static none = new EnumDocumentEmailTag(0, "None", "enum_document_email_tag_none");
  public static documentIdSummary = new EnumDocumentEmailTag(1, "DocumentIdSummary", "enum_document_email_tag_document_id_summary");
  public static companyName = new EnumDocumentEmailTag(2, "CompanyName", "enum_document_email_tag_company_name");
  public static outletBusinessName = new EnumDocumentEmailTag(3, "OutletBusinessName", "enum_document_email_tag_outlet_business_name");
  public static totalNetPrice = new EnumDocumentEmailTag(4, "TotalNetPrice", "enum_document_email_tag_total_net_price");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDocumentEmailTag.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDocumentEmailTag.none; }
  public isDocumentIdSummary() { return this === EnumDocumentEmailTag.documentIdSummary; }
  public isCompanyName() { return this === EnumDocumentEmailTag.companyName; }
  public isOutletBusinessName() { return this === EnumDocumentEmailTag.outletBusinessName; }
  public isTotalNetPrice() { return this === EnumDocumentEmailTag.totalNetPrice; }

  public static getValues(): readonly EnumDocumentEmailTag[] {
    return EnumDocumentEmailTag.allValues;
  }

  public static getValuesExcept0(): readonly EnumDocumentEmailTag[] {
    return EnumDocumentEmailTag.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDocumentEmailTag {
    const found = EnumDocumentEmailTag.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDocumentEmailTag - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDocumentEmailTag): EnumDocumentEmailTag {
    const found = name ? EnumDocumentEmailTag.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDocumentEmailTag - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDocumentEmailTag>): boolean {
    return this.key === other?.key;
  }
}